const {h, render, Component} = require('preact');

class CardLinked extends Component {
  constructor(props) {
    super(props);
  }

  getLinkedCards() {
    if (this.props.claimDetails && this.props.claimDetails.linkedToCards && this.props.claimDetails.linkedToCards.length > 0){
      return this.props.claimDetails.linkedToCards.join(',<br/>')
    }
    return null;
  }

  render() {
    let linkedCards = this.getLinkedCards()
    if (linkedCards){
      return (
        <tr>
          <td>{I18n.translate("js.modules.support.linkedToCards")}</td>
          <td dangerouslySetInnerHTML={{ __html: linkedCards}}/>
        </tr>
      );
    }
    return null;
  }
}

module.exports = CardLinked
